/* @flow strict */

import * as React from 'react';
import Modal from '/client/src/components/Modal';
import './styles.scss';

type PropsType = {
  isOpen: boolean,
  handleClose: () => void,
  handleConnect: (username: string, apiKey: string) => void
};


const MailchimpConnectForm = ({ isOpen, handleClose, handleConnect }: PropsType): React.Element<'div'> => {
    const [username, setUsername] = React.useState('');
    const [apiKey, setApiKey] = React.useState('');

    const handleSubmit = () => {
        handleClose();
        handleConnect(username, apiKey);
    };

    return (
      <>
        {isOpen ?
          <Modal
            altView
            opened={isOpen}
            onClose={handleClose}
          >
            <div className="modal-dialog customModal EditProfileModal" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h4 className="modal-title">Connect to Mailchimp</h4>
                </div>
                <div className="modal-body">

                  <form>
                    <div className="form-group">
                      <label htmlFor="firstname">Mailchimp Username</label>
                      <input
                        type="text"
                        className="form-control"
                        id='username'
                        onChange={(e) => setUsername(e.target.value)}
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="lastname">Mailchimp API Key</label>
                      <input
                        type="text"
                        className="form-control"
                        id='apikey'
                        onChange={(e) => setApiKey(e.target.value)}
                      />
                    </div>
                  </form>

                </div>
                <div className="modal-footer">
                  <button className="btn btn-gray" onClick={handleClose}>Close</button>
                  <button className="btn btn-pink" onClick={handleSubmit}>Connect</button>
                </div>
              </div>
            </div>
          </Modal>
        : null}
      </>

    );
};

export default MailchimpConnectForm;
